import QuickEditOverlay from './QuickEditOverlay';

export default QuickEditOverlay;
